import { TenantName, Tenant } from '@packlink/packlink-sdk';

const DEFAULT_PLATFORM = 'PRO';
const DEFAULT_PLAT_COUNTRY_BY_PLATFORM = {
  CORREOS: 'ES',
  DPDBBE: 'UN',
  EBAY: 'ES',
  PAYPAL: 'ES',
  PRO: 'UN'
};
const getAuthTenantName = () => {
  var _params$get, _params$get2;
  // As Auth is (for now) SSR, window could not be available in build time
  // TODO: https://auctane.atlassian.net/browse/WLE-315
  if (typeof window === 'undefined') {
    return TenantName.PACKLINKPRO;
  }
  const params = new URLSearchParams(window.location.search);
  const tenantId = params.get('tenant_id');
  if (tenantId) {
    return TenantName[tenantId];
  }
  const platform = (_params$get = params.get('platform')) !== null && _params$get !== void 0 ? _params$get : DEFAULT_PLATFORM;
  const platformCountry = (_params$get2 = params.get('platform_country')) !== null && _params$get2 !== void 0 ? _params$get2 : DEFAULT_PLAT_COUNTRY_BY_PLATFORM[platform];
  try {
    const tenant = Tenant.mapPlatAndPlatCountryToTenant(platform, platformCountry);
    return tenant.name;
  } catch {
    return null;
  }
};

export { getAuthTenantName };
//# sourceMappingURL=auth.js.map
